export default "__VITE_ASSET__D9U7ch5A__"